module.exports = __webpack_public_path__ + "img/hubspot-svgrepo-com.01a70517.svg";